import React, { useEffect, useState, useRef } from "react";
import face1 from "../../assets/images/faces/15.jpg";
import face3 from "../../assets/images/faces/22.jpg";
import EmojiPicker from "emoji-picker-react";
import axios from "axios";
import messagesImg from "../../assets/images/messages.png";
import Spinner from "../LoadingSpinner/loadingSpinner";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import api from "../../api";

const Rightcard = ({ conversation, selectedExpert, conversationId }) => {
  const [languageData, setLanguageData] = useState(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [messageText, setMessageText] = useState("");
  const textAreaRef = useRef(null);
  const emojiPickerRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [loading, setLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [messages, setMessages] = useState({
    total: 0,
    data: [],
  });

  const [messageForm, setMessageForm] = useState({
    expert_id: null,
    content: "",
  });
const chatContentRef = useRef(null);

  useEffect(() => {
    if (selectedExpert?.expert?.id) {
      setMessageForm((prev) => ({
        ...prev,
        expert_id: selectedExpert.expert.id,
      }));
    }
  }, [selectedExpert]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target) &&
        !event.target.closest(".emoji-button")
      ) {
        setShowEmojiPicker(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/messages/${cookieLang}.json`)
        .then((data) => setLanguageData(data))
        .catch((error) => console.error("Error loading language file:", error));
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  useEffect(() => {
    if (!conversation) return;

    const fetchMessages = async () => {
      try {
        setLoading(true);

        const response = await api.get(`/messaging/conversations/messages`, {
          params: {
            conversation_id: conversation?.id || conversationId,
          },
        });

        setMessages({
          total: response.data.data.length,
          data: response.data.data.sort(
            (a, b) => new Date(a.date) - new Date(b.date),
          ),
        });

        setTimeout(() => {
        if (chatContentRef.current) {
          chatContentRef.current.scrollTop =
            chatContentRef.current.scrollHeight;
        }
      }, 0);

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [conversation]);

  if (!languageData) {
    return <div></div>;
  }

  const handleTextAreaChange = (e) => {
    setMessageText(e.target.value);
    setCursorPosition(e.target.selectionStart);
  };

  const handleTextAreaClick = () => {
    if (textAreaRef.current) {
      setCursorPosition(textAreaRef.current.selectionStart);
    }
  };

  const onEmojiClick = (emojiObject) => {
    const text = messageForm.content || "";
    const start = text.slice(0, cursorPosition);
    const end = text.slice(cursorPosition);

    const newText = start + emojiObject.emoji + end;
    const newCursorPos = cursorPosition + emojiObject.emoji.length;

    setMessageForm((prev) => ({
      ...prev,
      content: newText,
    }));

    setCursorPosition(newCursorPos);
    setShowEmojiPicker(false);

    setTimeout(() => {
      if (textAreaRef.current) {
        textAreaRef.current.focus();
        textAreaRef.current.selectionStart = newCursorPos;
        textAreaRef.current.selectionEnd = newCursorPos;
      }
    }, 0);
  };

const formatTime = (date) => {
  const d = new Date(date);

  const today = new Date();
  const isToday =
    d.getUTCFullYear() === today.getUTCFullYear() &&
    d.getUTCMonth() === today.getUTCMonth() &&
    d.getUTCDate() === today.getUTCDate();

  return isToday
    ? d.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "UTC",
      })
    : d.toLocaleString([], {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "UTC",
      });
};

  const SendMessage = async () => {
    try {
      setLoading(true);

      const response = await api.post(
        `/messaging/conversations/messages/send`,
        {
          expert_id: conversation.id,
          content: messageForm.content,
        },
      );

      if (!messageForm.content.trim()) return;

      const newMessage = {
        sender: 2,
        content: messageForm.content,
        date: new Date().toISOString(),
        type: "text",
      };

      setMessages((prev) => ({
        ...prev,
        data: [...prev.data, newMessage],
      }));

      setMessageForm((prev) => ({
        ...prev,
        content: "",
      }));
      /*  setMessageForm((prev) => ({
        ...prev,
        content: "",
      })); */
    } catch (error) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: languageData?.alert?.title,
        text:  error.response?.data?.details?.[0]?.message === "\"content\" is not allowed to be empty"
            ?   languageData?.alert?.empty_message
            : languageData?.alert?.description,
        confirmButtonText: "OK",
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  
  if (!languageData) {
    return <div></div>;
  }

 if (!conversation && !conversationId) {
    return (
      <div className="chat-content main-chat-area border text-start d-flex align-items-center justify-content-center">
        <div className="flex flex-column align-items-center justify-content-center">
          <img src={messagesImg} alt="Messages" className="w-180" />
          <h6>{languageData.select_message}</h6>
        </div>
        <div className="chat-footer relative hidden">
          <textarea
            ref={textAreaRef}
            className="form-control no-resize"
            id="messageInput"
            placeholder={languageData.type_message}
            rows="2"
            value={messageForm.content}
            onChange={(e) =>
              setMessageForm((prev) => ({
                ...prev,
                content: e.target.value,
              }))
            }
            /*    onChange={handleTextAreaChange} */
            onClick={handleTextAreaClick}
            onKeyUp={handleTextAreaClick}
          />

          <div className="d-flex justify-content-end res-w-100">
            <div className="relative emoji-picker-container mx-2">
              {showEmojiPicker && (
                <div className="emoji-picker"
                  ref={emojiPickerRef}
                >
                  <EmojiPicker
                    onEmojiClick={onEmojiClick}
                    searchPlaceholder="Search emoji..."
                    skinTonesDisabled
                    width={300}
                    height={500}
                    searchDisabled={false}
                    lazyLoadEmojis={true}
                    previewConfig={{ showPreview: false }}
                  />
                </div>
              )}
              <a data-interaction="emoji_button"
                aria-label="emoji-picker"
                className="btn btn-icon btn-warning-light emoji-button"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowEmojiPicker(!showEmojiPicker);
                }}
              >
                <i className="ri-emotion-line"></i>
              </a>
            </div>

            <a data-interaction="add_file_button"
              aria-label="anchor"
              id="uploadBtn"
              className="btn btn-icon me-2 btn-primary-light pointer-event-none"
              href="#"
            >
              <i className="ri-attachment-2"></i>
            </a>

            <a data-interaction="voice_message_button"
              aria-label="anchor"
              id="voiceBtn"
              className="btn btn-icon me-2 recorder btn-success-light pointer-event-none  "
              href="#"
            >
              <i className="ri-mic-line"></i>
            </a>
            <a data-interaction="send_message_button"
              className="btn btn-primary d-inline-flex"
              id="sendButton"
              onClick={SendMessage}
            >
              <i className="ri-send-plane-2-line me-2"></i>
              {languageData.btn_send}
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-chat-area border text-start">
      <div className="d-flex align-items-center p-2 border-bottom">
        <div className="me-2 lh-1">
          <span className="avatar avatar-lg online me-2 avatar-rounded chatstatusperson">
            <img
              className="chatimageperson"
              src={conversation?.expert?.image || face3}
              alt="Profile"
            />
          </span>
        </div>
        <div className="flex-fill">
          <a data-interaction="expert_image"
            href="#"
            className="chatnameperson responsive-userinfo-open"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight"
            aria-controls="offcanvasRight"
          >
            {conversation?.expert?.nickname}
            <p className="text-success mb-0 chatpersonstatus">Clairaudient</p>
          </a>
        </div>
      </div>
  
      <div
       ref={chatContentRef}
        className="chat-content overflow-scroll"
        id="main-chat-content"
      >
        <ul className="list-unstyled" id="chatList">
          {messages.data.map((message, index) => (
            <li
              key={index}
              className={
                message.sender === 2 ? "chat-item-end" : "chat-item-start"
              }
            >
              <div className="chat-list-inner">
                 {message.sender === 1 && (
          <span className="avatar avatar-lg online me-2 avatar-rounded chatstatusperson">
            <img
              className="chatimageperson"
              src={conversation?.expert?.image || face3}
              alt="Profile"
            />
          </span>
        )}
                <div className={message.sender === 2 ? "me-0" : "ms-3"}>
                  <span className="chatting-user-info">
                    <span className="msg-sent-time">
                      <span className="chat-read-mark align-middle">
                        <i className="ri-check-double-line"></i>
                      </span>
                      {/* {message.sender !== 2 && message.sender}{" "} */}
                      <span>{formatTime(message.date)}</span>{" "}
                    </span>
                  </span>
                  <div>
                    {" "}
                    <p className="mb-0">{message.content}</p>
                    
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
        {/* Spinner Overlay */}
        {loading && (
          <div className="spinner-overlay">
            <Spinner />
          </div>
        )}
      </div>
      <div className="chat-footer relative ">
        <textarea
          ref={textAreaRef}
          className="form-control no-resize"
          id="messageInput"
          placeholder={languageData.type_message}
          rows="2"
          value={messageForm.content}
          onChange={(e) =>
            setMessageForm((prev) => ({
              ...prev,
              content: e.target.value,
            }))
          }
          /*    onChange={handleTextAreaChange} */
          onClick={handleTextAreaClick}
          onKeyUp={handleTextAreaClick}
        />

        <div className="d-flex justify-content-end res-w-100">
          <div className="relative emoji-picker-container mx-2">
            {showEmojiPicker && (
              <div className="emoji-picker"
                ref={emojiPickerRef}
               
              >
                <EmojiPicker
                  onEmojiClick={onEmojiClick}
                  searchPlaceholder="Search emoji..."
                  skinTonesDisabled
                  width={300}
                  height={500}
                  searchDisabled={false}
                  lazyLoadEmojis={true}
                  previewConfig={{ showPreview: false }}
                />
              </div>
            )}
            <a data-interaction="show_emoji_button"
              aria-label="emoji-picker"
              className="btn btn-icon btn-warning-light emoji-button"
              onClick={(e) => {
                e.stopPropagation();
                setShowEmojiPicker(!showEmojiPicker);
              }}
            >
              <i className="ri-emotion-line"></i>
            </a>
          </div>

          <a data-interaction="add_file_button"
            aria-label="anchor"
            id="uploadBtn"
            className="btn btn-icon me-2 gray_color btn-primary-light pointer-event-none "
            href="#"
          >
            <i className="ri-attachment-2"></i>
          </a>

          <a data-interaction="voice_message_button"
            aria-label="anchor"
            id="voiceBtn"
            className="btn btn-icon me-2 gray_color recorder btn-success-light pointer-event-none "
            href="#"
          >
            <i className="ri-mic-line"></i>
          </a>
          <a data-interaction="send_message_button"
            className="btn btn-primary d-inline-flex"
            id="sendButton"
            onClick={SendMessage}
          >
            <i className="ri-send-plane-2-line me-2"></i>
            {languageData.btn_send}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Rightcard;
